import { render, staticRenderFns } from "./DiscussSecondVirtualList.vue?vue&type=template&id=55adb5ed&"
import script from "./DiscussSecondVirtualList.vue?vue&type=script&lang=js&"
export * from "./DiscussSecondVirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports